import React from 'react';

const EmailButton = ({
	recipientEmail,
	subject,
	body,
	buttonText,
	identifier,
	className,
}) => {
	const createMailtoLink = () => {
		const subjectParts = [subject, identifier].filter((value) => (
			value !== null &&
			value !== undefined &&
			String(value).trim() !== ''
		));

		const emailSubject = subjectParts.length > 0
			? subjectParts.join(' - ')
			: 'Subject';

		const parameters = new URLSearchParams();
		parameters.set('subject', emailSubject);

		if (body !== null && body !== undefined && String(body).trim() !== '') {
			parameters.set('body', String(body));
		}

		window.location.href = `mailto:${recipientEmail}?${parameters.toString()}`;
	};

	const buttonClassName = className || (
		'mt-4 mr-2 border bg-black px-4 py-2 text-white shadow-sm hover:bg-gray-700'
	);

	return (
		<button
			type="button"
			className={buttonClassName}
			onClick={createMailtoLink}
		>
			{buttonText}
		</button>
	);
};

export default EmailButton;
